import { CardContentProps } from 'shared/mui/Card/CardContent/CardContent';

import { CardContentStyled } from './FilterDrawerContent.styled';

export type FilterContentProps = CardContentProps;

export const FilterDrawerContent: React.FC<FilterContentProps> = ({ children, ...restProps }) => {
  return <CardContentStyled {...restProps}>{children}</CardContentStyled>;
};
